import { useLayoutEffect, useRef, useState } from "react"
import { isTextCut } from "./textCut"


/**
 * A ref for a one-line label and whether it is cut right now (CU-869fmjzrg): measured on mount, when `text` changes
 * and whenever the label's box resizes (menu opened, window resized), so a tooltip with the full text shows only
 * when the "…" is really there.
 */
export default function useTextCut(text) {
	const ref = useRef(null)
	const [cut, setCut] = useState(false)

	useLayoutEffect(() => {
		const el = ref.current
		if (!el) return
		const measure = () => setCut(isTextCut(el))
		measure()
		if (typeof ResizeObserver === 'undefined') return
		const observer = new ResizeObserver(measure)
		observer.observe(el)
		return () => observer.disconnect()
	}, [text])

	return [ref, cut]
}
